import { IMapEvents } from '../../interfaces/map-event.interface';

export const BaiduMapEvents: IMapEvents = {
  click: 'click',
  dblclick: 'dblclick',
  rightclick: 'rightclick',
  rightdblclick: 'rightdblclick',
  mouseover: 'mouseover',
  mousedown: 'mousedown',
  mouseout: 'mouseout',
  mousemove: 'mousemove',
  mouseup: 'mouseup',
  moveend: 'moveend',
  movestart: 'movestart',
  moving: 'moving',
  drag: 'drag',
  zoomend: 'zoomend',
  dragend: 'dragend',
  dragging: 'dragging',
};
